import { COUNTIES } from "@/data/content";

export const Marquee = () => {
  const items = [...COUNTIES, ...COUNTIES];
  return (
    <section data-testid="county-marquee" className="relative bg-white border-y border-slate-200 py-8 md:py-12 overflow-hidden">
      <div className="flex w-max marquee-track">
        {items.map((c, i) => (
          <span key={i} data-testid={i < COUNTIES.length ? `marquee-item-${c.toLowerCase()}` : undefined}
            className="flex items-center gap-10 pr-10 text-5xl md:text-8xl font-extrabold tracking-[-0.04em] text-[#0A192F] whitespace-nowrap">
            {i % 2 ? <span className="font-serif-i font-normal tracking-normal text-sky-700">{c}</span> : c}
            <svg viewBox="0 0 24 24" className="w-6 h-6 md:w-10 md:h-10 text-sky-500 shrink-0" aria-hidden="true"><path d="M9 2h6v7h7v6h-7v7H9v-7H2V9h7z" fill="currentColor" /></svg>
          </span>
        ))}
      </div>
    </section>
  );
};
